module.exports = __webpack_public_path__ + "img/IOBA.b700271b.png";